import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteStaffUserAction,
  getAllAdminUsersAction,
  updateUserInfoAction,
} from "../../pages/admin-dashboard-page/userAction";

import { NoData } from "../no-data/NoData";
import { toast } from "react-toastify";

const initialState = {
  fName: "",
  lName: "",
  branch: "",
  email: "",
  role: "",
  status: "",
};

export const StaffTable = () => {
  const dispatch = useDispatch();
  const { isLoading, staffs, user } = useSelector((state) => state.user);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState(initialState);

  useEffect(() => {
    // fetch all the staffs
    !staffs.length && shouldFetch && dispatch(getAllAdminUsersAction());
    setShouldFetch(false);
  }, [staffs, shouldFetch, dispatch]);

  const handleOnDelete = (_id) => {
    if (user?.role !== "admin") {
      toast.error("You are not authorized to delete a staff!");
      return;
    }
    if (window.confirm("Are you sure you want to delete this staff?")) {
      dispatch(deleteStaffUserAction(_id));
    }
  };

  const handleOnEdit = (staffDetails) => {
    setShow(true);
    setForm(staffDetails);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fName, lName, branch, email, role, status } = form;

    dispatch(
      updateUserInfoAction({ fName, lName, branch, email, role, status })
    );
    setShow(false);
  };

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />;
  }
  if (!staffs?.length) {
    return <NoData />;
  }

  return (
    <div>
      {/* Edit Staff Modal */}
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Staff Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="3">
                First Name
              </Form.Label>
              <Col>
                <Form.Control
                  name="fName"
                  onChange={handleOnChange}
                  value={form.fName}
                  type="text"
                  placeholder="Enter First Name"
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 formgroup">
              <Form.Label column sm="3">
                Last Name
              </Form.Label>
              <Col>
                <Form.Control
                  name="lName"
                  onChange={handleOnChange}
                  value={form.lName}
                  type="text"
                  placeholder="Enter Last Name"
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 formgroup">
              <Form.Label column sm="3">
                Email
              </Form.Label>
              <Col>
                <Form.Control
                  name="email"
                  onChange={handleOnChange}
                  value={form.email}
                  type="email"
                  placeholder="Enter Email"
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 formgroup">
              <Form.Label column sm="3">
                Branch
              </Form.Label>
              <Col>
                <Form.Select
                  onChange={handleOnChange}
                  name="branch"
                  value={form.branch}
                  required
                >
                  <option>-- Select a branch --</option>
                  <option value="all">All</option>
                  <option value="sydney">Sydney</option>
                  <option value="canberra">Canberra</option>
                </Form.Select>
              </Col>
            </Form.Group>

            {/* Role Field */}
            <Form.Group as={Row} className="mb-3 formgroup">
              <Form.Label column sm="3">
                Role
              </Form.Label>
              <Col>
                <Form.Select
                  onChange={handleOnChange}
                  name="role"
                  value={form.role}
                  required
                >
                  <option value="">-- Select Role --</option>
                  <option value="admin">Admin</option>
                  <option value="staff">Staff</option>
                </Form.Select>
              </Col>
            </Form.Group>

            {/* Status Field */}
            <Form.Group as={Row} className="mb-3 formgroup">
              <Form.Label column sm="3">
                Status
              </Form.Label>
              <Col>
                <Form.Select
                  onChange={handleOnChange}
                  name="status"
                  value={form.status}
                  required
                >
                  <option value="">-- Select Status --</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Col>
            </Form.Group>

            <div className="d-grid">
              <Button variant="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="mb-3">{staffs?.length} staffs found</div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Role</th>
            <th>Status</th>
            <th>Branch</th>
            <th>Email</th>
            <th>Added By</th>
            <th>Added Date</th>
            {user?.role === "admin" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {staffs?.map((staff, index) => (
            <tr key={staff._id}>
              <td>{index + 1}</td>
              <td>{`${staff.fName} ${staff.lName}`}</td>
              <td>{staff.role}</td>
              <td>{staff.status}</td>
              <td>{staff.branch}</td>
              <td>{staff.email}</td>
              <td>{staff.addedBy?.adminName}</td>
              <td>{new Date(staff.createdAt).toLocaleDateString()}</td>

              {user?.role === "admin" && (
                <td className="d-flex gap-2">
                  <Button variant="warning" onClick={() => handleOnEdit(staff)}>
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => handleOnDelete(staff._id)}
                  >
                    Delete
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
